import LogIn from '../../auth/components/Login';

export default function SignInPage() {
    return <LogIn />;
}
